import { Container } from "@mui/material";
import { HomeOfHomes } from "../../components/Home/HomeOfHomes";

const Site = () => {
	return (
		<>
			<Container
				sx={{
					display: "flex",
					height: "100vh",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<HomeOfHomes />
			</Container>
		</>
	);
};

export { Site };
